import type { Game } from '@playgame/types'
import { computed, useState } from '#imports'

// Slice of the playgame module's state read here; source of truth is usePlaygameState.
interface PlaygameState {
    paymentsVisible: boolean
    focusedGame: string
    games: Map<string, Game>
}

export const usePlaygameDeposit = () => {
    // Read playgame state via its useState keys (not the composable) to avoid a
    // runtime dependency from payment on playgame. Games live in their own
    // `playgame-games` key; the `Game` import is type-only.
    const playgameState = useState<PlaygameState>('playgame')
    const gamesState = useState<Map<string, Game>>('playgame-games')

    const paymentsVisible = computed(() => playgameState.value?.paymentsVisible)

    const games = computed(() => gamesState.value)

    const game = computed(() => {
        if (!playgameState.value?.focusedGame) return

        return gamesState.value?.get(playgameState.value.focusedGame)
    })

    return {
        paymentsVisible,
        games,
        game,
    }
}
